<template>
  <div>
    <vue-headful title="Vacatures" />
    <Header page_title="Vacatures" />
    <div>
      <div class="app-body container-fluid">
        <div v-if="results ? results.data && results.data.length > 0:false" class="">
          <p v-if="results.meta" class="mb-3"><strong>{{ results.meta.total }}</strong> archief vacature{{ results.data.length > 1 ? "s" : "" }}</p>
          <div class="mb-5">
            <JobCard
              v-for="job in results.data"
              :key="job.id"
              :job="job"
              :job_ids="ids"
              :closed="true"
              :arrow="true"
            />
            <Pagination :results="results" :api="api" @page-change="pageChanged" />
          </div>
        </div>
        <div v-else class="mb-4">
          <div class="sd-notif warning"><svg-icon icon="information" class="warning-icon"/> Er zijn op dit moment geen vacatures gearchiveerd.</div>
        </div>
        <div class="">
          <router-link
            :to="{ name: 'job_step-1' }"
            title="Plaats een vacature"
            class="btn btn-warning btn-block"
            v-ripple="'rgba(255, 255, 255, 0.35)'"
          >
            Plaats vacature
          </router-link>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import JobCard from "@/components/JobCard.vue";

export default {
  data: function() {
    return {
      api: "jobs/archived",
      results: null,
      ids: null
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  methods: {
    async fetchData() {
      this.$store.state.loading = true;
      // this.archived = (await this.getTokenAPIList("jobs/archived")) || 0;
      this.results = await this.getListwithPages("jobs/archived");
      if (this.results.data.length > 1) {
        this.ids = this.results.data.map(({ id }) => id);
      }
      this.$store.state.loading = false;
    },
    async pageChanged(data) {
      this.results = await this.getListwithPages(data);
    }
  },
  components: {
    JobCard
  }
};
</script>

<style scoped></style>
